"use strict";
// Copyright 2019-2022 Unique Network (Gibraltar) Ltd.
// This file is part of Unique Network.
Object.defineProperty(exports, "__esModule", { value: true });
const atParam = { name: 'at', type: 'Hash', isOptional: true };
const fn = (description, params, type) => ({
    description,
    params: [...params, atParam],
    type,
});
exports.default = {
    types: {},
    rpc: {
        lastCollectionIdx: fn('Get the latest created collection id', [], 'u32'),
        collectionById: fn('Get collection by id', [{ name: 'id', type: 'u32' }], 'Option<RmrkTraitsCollectionCollectionInfo>'),
        nftById: fn('Get NFT by collection id and NFT id', [
            { name: 'collectionId', type: 'u32' },
            { name: 'nftId', type: 'u32' },
        ], 'Option<RmrkTraitsNftNftInfo>'),
        accountTokens: fn('Get tokens owned by an account in a collection', [
            { name: 'accountId', type: 'AccountId32' },
            { name: 'collectionId', type: 'u32' },
        ], 'Vec<u32>'),
        nftChildren: fn('Get NFT children', [
            { name: 'collectionId', type: 'u32' },
            { name: 'nftId', type: 'u32' },
        ], 'Vec<RmrkTraitsNftNftChild>'),
        collectionProperties: fn('Get collection properties', [
            { name: 'collectionId', type: 'u32' },
            { name: 'filterKeys', type: 'Vec<String>', isOptional: true },
        ], 'Vec<RmrkTraitsPropertyPropertyInfo>'),
        nftProperties: fn('Get NFT properties', [
            { name: 'collectionId', type: 'u32' },
            { name: 'nftId', type: 'u32' },
            { name: 'filterKeys', type: 'Vec<String>', isOptional: true },
        ], 'Vec<RmrkTraitsPropertyPropertyInfo>'),
        nftResources: fn('Get NFT resources', [
            { name: 'collectionId', type: 'u32' },
            { name: 'nftId', type: 'u32' },
        ], 'Vec<RmrkTraitsResourceResourceInfo>'),
        nftResourcePriority: fn('Get NFT resource priorities', [
            { name: 'collectionId', type: 'u32' },
            { name: 'nftId', type: 'u32' },
            { name: 'resourceId', type: 'u32' },
        ], 'Option<u32>'),
        base: fn('Get base info', [{ name: 'baseId', type: 'u32' }], 'Option<RmrkTraitsBaseBaseInfo>'),
        baseParts: fn('Get all Base\'s parts', [{ name: 'baseId', type: 'u32' }], 'Vec<RmrkTraitsPartPartType>'),
        themeNames: fn('Get Base\'s theme names', [{ name: 'baseId', type: 'u32' }], 'Vec<Bytes>'),
        themes: fn('Get Theme\'s keys values', [
            { name: 'baseId', type: 'u32' },
            { name: 'themeName', type: 'String' },
            { name: 'keys', type: 'Option<Vec<String>>' },
        ], 'Option<RmrkTraitsTheme>'),
    },
};
//# sourceMappingURL=definitions.js.map